import React, { createRef, Component } from "react";
import { Map, WMSTileLayer, ScaleControl, Marker, GeoJSON, Pane, } from "react-leaflet";
import {
  Button,
  Segment,
  Grid,
  Message,
  Icon,
  Popup,
  Menu,
} from "semantic-ui-react";
import L from "leaflet";
import Control from "react-leaflet-control";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExpand,
  faWindowClose,
  faChartBar,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList,
} from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";

import domain from "../../domain";
import DateSlider from "./DateSlider";
import { isNull } from "util";
import colors from "../../colors";
import { FadeLoader } from "react-spinners";
import { connect } from "react-redux";
import {
  common_state,
  changeBaseLayer,
  displayBaseLayerPanel,
} from "../../redux_components/actions/CommonActions";
import { showInfo_f } from "../../redux_components/actions/ETActions";
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";

import VenueMarkers from './VenueMarkers';
import data from '../assets/data';


var parse = require("html-react-parser");

library.add(
  faWindowClose,
  faChartBar,
  faExpand,
  faCompress,
  faGlobeAsia,
  faInfoCircle,
  faThList
);

const units = {
  yAxis: {
    Evapotranspiration: "mm/day",
    Evapotranspiration_WB: "mm/day",
  },
};

const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pointInfo: null,

      legend: null,
      legendVisible: true,
      visibleRight: false,
      isExpand: false,
      zoom: window.innerWidth > 1000 ? 4 : 3,
      activeDrags: 0,
      layerloading: false,
      markerenable: true,
      layer:'sat'

      // onClickDetails:{},
      // highlightState:null
      // selected:this.props.selected
    };
  }
  mapRef = createRef();
  resetZoom = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(25.12539, 80.00164));
  };
  displayLegend = () => {
    this.setState({
      legendVisible: !this.state.legendVisible,
    });
  };

  componentDidMount() {
    let layer =
      this.props.selected !== null
        ? this.props.selected.toLowerCase().split(" ").join("-") +
        ":" +
        this.props.selectedLayer[this.props.selected]
        : "india states";
    let wms_url =
      this.props.selected !== null
        ? `${domain.Geoserver}/nhp_${this.props.selected
          .toLowerCase()
          .split(" ")
          .join("-")}/wms`
        : this.props.wms_url_base_layers;
    this.props.common_state();
    const colors_range_et = [
      "#d6e4ff",
      "#adc6ff",
      "#85a5ff",
      "#597ef7",
      "#2f54eb",
      "#2949cc",
      "#1d39c4",
      "#1d39c4",
      "#10239e",
      "#061178",
      "#030852",
      "#f0f5ff",
      "#c7d1e6",
    ];
    const grades_et = [
      "0 - 1",
      "1 - 2",
      "2 - 3",
      "3 - 4",
      " 4 - 5",
      "5 - 6",
      "6 - 7",
      " 7 - 8",
      "8 - 9",
      "9 - 10",
      "10",
      "Cloud",
      "No Data",
    ];

    let img = grades_et.map((value, key) => {
      // console.log(index)
      return (
        <React.Fragment>
          <i key={key} style={{ background: `${colors_range_et[key]}` }}></i>{" "}
          {value} <br />{" "}
        </React.Fragment>
      );
    });
    this.getLegendGraphic(wms_url, layer).then((legend) => {
      console.log(layer);
      //   this.props.setLegend(legend);

      this.setState({
        legend: img,
      });

    });

  }
  componentDidUpdate(prevProps, PrevState) {
    // console.log(this.props.selected,prevProps.selected)
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      let layer =
        this.props.selected !== null
          ? this.props.selected.toLowerCase().split(" ").join("-") +
          ":" +
          this.props.selectedLayer[this.props.selected]
          : "india states";
      let layer_type = this.props.selectedLayer[this.props.selected].split(
        "_"
      )[3];
      console.log(layer_type)
      let wms_url =
        this.props.selected !== null
          ? `${domain.Geoserver}/nhp_${this.props.selected
            .toLowerCase()
            .split(" ")
            .join("-")}/wms`
          : this.props.wms_url_base_layers;
      const colors_range_et = [
        "#d6e4ff",
        "#adc6ff",
        "#85a5ff",
        "#597ef7",
        "#2f54eb",
        "#2949cc",
        "#1d39c4",
        "#1d39c4",
        "#10239e",
        "#061178",
        "#030852",
        "#f0f5ff",
        "#c7d1e6",
      ];
      const grades_et = [
        "0 - 1",
        "1 - 2",
        "2 - 3",
        "3 - 4",
        " 4 - 5",
        "5 - 6",
        "6 - 7",
        " 7 - 8",
        "8 - 9",
        "9 - 10",
        "10",
        "Cloud",
        "No Data",
      ];

      let img = grades_et.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i key={key} style={{ background: `${colors_range_et[key]}` }}></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });
      const colors_range_et_wb = [
        "#d6e4ff",
        "#adc6ff",
        "#85a5ff",
        "#597ef7",
        "#2f54eb",
        "#2949cc",
        "#1d39c4",
        "#1d39c4",
        "#10239e",
        "#061178",
        "#030852",
        "#f0f5ff",
        "#c7d1e6",
      ];
      const grades_et_wb = [
        "0 - 1",
        "1 - 2",
        "2 - 3",
        "3 - 4",
        " 4 - 5",
        "5 - 6",
        "6 - 7",
        " 7 - 8",
        "8 - 9",
        "9 - 10",
        "10",
      ];

      let img_wb = grades_et_wb.map((value, key) => {
        // console.log(index)
        return (
          <React.Fragment>
            <i
              key={key}
              style={{ background: `${colors_range_et_wb[key]}` }}
            ></i>{" "}
            {value} <br />{" "}
          </React.Fragment>
        );
      });

      this.getLegendGraphic(wms_url, layer).then((legend) => {
        console.log(layer);
        //   this.props.setLegend(legend);
        if (layer_type === "WB") {
          this.setState({
            legend: img_wb,
          });
        } else {
          this.setState({
            legend: img,
          });
        }
      });

    }

    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 20;
    let height = 10;
    let fontName = "Serif";

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=fontName:${fontName}`;

    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({
      visibleRight: !this.state.visibleRight,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };
  handleExpand = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    });
  };

  highlightState = (feature, layer) => {
    layer.setStyle({
      weight: 3,
      color: "#828faf",
      fillOpacity: 0,
    });
  };
  handleMark = () => {
    this.setState({ markerenable: true });
  };
  loading = (e) => {
    this.setState({
      layerloading: true,
    });
    // console.log(e)
  };
  load = (e) => {
    this.setState({
      layerloading: false,
    });
  };
  highlightState = (feature, layer) => {
    // const map = this.mapRef.current.leafletElement
    const map = this.mapRef.current.leafletElement;
    console.log(feature.properties);
    layer.setStyle({
      weight: 2,
      color: "#000000",
      fillOpacity: 0,
      // fill:false
    });

    layer.on({
      mouseover: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#0000ff",
          fillOpacity: 0,
          //  fill:false
        });
      },
      mouseout: (event) => {
        layer.setStyle({
          weight: 3,
          color: "#000000",
          fillOpacity: 0,
          //  fill:false
        });
      },
    });
    let string = feature.properties.state !== "undefined"

      ? feature.properties.state : ''
    // console.log(string)
    // let label = L.marker(layer.getBounds().getCenter(), {
    //   icon: L.divIcon({
    //     className: "label",
    //     html: `<h5 color='red'>${string}</h5>`,
    //     iconSize: [40, 40],
    //   }),
    // }).addTo(map);
    // if (label !== undefined) {
    //   map.removeLayer(label);
    // }

  };

  render() {
    let test;
    delete L.Icon.Default.prototype._getIconUrl;
    console.log(this.props.india_states_boundary);
    // L.Icon.Default.mergeOptions({
    //   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    //   iconUrl: require("leaflet/dist/images/marker-icon.png"),
    //   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    // });

    if (this.props.selected === "Evapotranspiration") {
      test = "Evapotranspiration";
    } else if (this.props.selected === "Evapotranspiration_WB") {
      test = "Evapotranspiration (WB)";
    }

    return (
      <Map
        ref={this.mapRef}
        center={this.props.center}
        minZoom={this.props.minZoom}
        maxZoom={this.props.maxZoom}
        zoom={this.props.zoom}
        // onclick={this.props.onMapClick}
        style={{ backgroundColor: "#fff" }}
        attributionControl={this.props.attributionControl}
        crs={this.props.crs}
      >
        {this.props.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.props.layers}
            url={this.props.url}
            format="image/png"
            transparent={true}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
        {/* {this.props.india_states_boundary !== null ?
          <Pane className="GridcellsPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.india_states_boundary.features[0].id}
              data={this.props.india_states_boundary}
              onEachFeature={this.highlightState}
            // crs={crs}
            // zIndex={10}
            // transparent={true}
            />
          </Pane> : null
        } */}

        {/* {this.props.selected !== null ? (
          <WMSTileLayer
            url={`${
              domain.Geoserver
              }/nhp_${this.props.selected
                .toLowerCase()
                .split(" ")
                .join("-")}/wms`}
            layers={
              "nhp_" +
              this.props.selected.toLowerCase().split(" ").join("-") +
              ":" +
              this.props.selectedLayer[this.props.selected]
            }
            format="image/png"
            zIndex={5}
            transparent={true}
            onloading={this.loading}
            onload={this.load}
          // interpolations="nearest neighbor"
          // format_options="dpi:300"
          // opacity={1}
          // crs={ crs}
          />
        ) : null} */}

        <VenueMarkers venues={data.venues} layer={this.props.baselayerselected}/>

        {this.props.latlng !== null ? (
          <Marker position={[this.props.latlng.lat, this.props.latlng.lng]} />
        ) : null}

        {this.props.metadata ? (
          <Control position="topleft">
            <Segment
              style={{
                marginLeft: "44px",
                marginTop: "-200px",
                width: window.innerWidth - (260 + 46 + 100),
                minHeight: window.innerHeight - 600,
              }}
            >
              <Grid
                columns="equal"
                divided
                style={{ marginLeft: "0rem", marginRight: "-3rem" }}
              >
                <Grid.Row style={{ paddingTop: "0em", paddingBottom: "0em" }}>
                  <Grid.Column>
                    <Button
                      basic
                      size="tiny"
                      floated="right"
                      compact
                      style={{ padding: "2px" }}
                      onClick={this.handlePopupClose}
                    >
                      <FontAwesomeIcon icon="window-close" size="lg" />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Control>
        ) : null}

        <Control position="topleft">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>
        {this.state.layerloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        
        {/* <Control position="topleft">
          <div>
            {this.props.showInfo ? (
              <div
                style={{
                  marginRight: "0px",
                  paddingLeft: "0rem",
                  paddingRight: "0rem",
                  marginLeft: "0px",
                }}
              >
                <Button
                  basic
                  attached="right"
                  floated="right"
                  size="tiny"
                  compact
                  style={{ padding: "5px" }}
                  onClick={this.props.showInfo_f}
                  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
                >
                  <FontAwesomeIcon icon="window-close" size="lg" />
                </Button>
                <Message
                  icon="map marker alternate"
                  info
                  warning={isNull(this.props.pointInfo)}
                  attached="bottom"
                >
                  <Icon name="map marker alternate" />
                  {this.props.pointInfo !== null ? (
                    <Message.Content>
                      <Message.Header>{this.props.selected}</Message.Header>
                      <b>Date:</b>&nbsp;{this.props.activeDate}
                      <br />
                      {isNull(this.props.pointInfo) ? (
                        <div>
                          <b>Data not available in this region</b>
                        </div>
                      ) : (
                          <div>
                            <b>Value:</b>&nbsp;{this.props.pointInfo}{" "}
                            {this.props.pointInfo !== "Cloud"
                              ? parse(units.yAxis[this.props.selected])
                              : null}
                          </div>
                        )}
                      <b></b>
                    </Message.Content>
                  ) : (
                      "Select a place within Indian boundary"
                    )}
                </Message>
              </div>
            ) : (
                <Popup
                  trigger={
                    <Button
                      size="tiny"
                      compact
                      style={{ padding: "8px" }}
                      onClick={this.props.showInfo_f}
                    >
                      <FontAwesomeIcon icon="info-circle" size="lg" />
                    </Button>
                  }
                  position="right center"
                >
                  <Popup.Content>
                    click this to know about what is in the point you clicked in
                    the map
                </Popup.Content>
                </Popup>
              )}
          </div>
        </Control> */}

        {/* {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control> : <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>} */}


        <Control position="bottomright">
          <OffCanvas
            width={180}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "pointer" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgba(255,255,255,0.5)",
                borderColor: "blue",
                top: "10px",
                marginRight: "10px",
                transform: "translate(-180px, 0px)",
              }}
            >
              <div>
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.props.displayBaseLayerPanel}
                    style={{
                      textAlign: "center",
                      marginLeft: `5px`,
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors["black"],
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Base Layers
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.props.baseLayers ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>
                {this.props.baseLayers ? (
                  <div>
                    <input
                      type="radio"
                      name="baselayer"
                      value="Satellite"
                      checked={this.props.baselayerselected === "Satellite"}
                      onChange={this.props.changeBaseLayer}
                    />{" "}
                    Satellite <br />
                    <input
                      type="radio"
                      name="baselayer"
                      value="Map"
                      checked={this.props.baselayerselected === "Map"}
                      onChange={this.props.changeBaseLayer}
                    />{" "}
                    Map
                  </div>
                ) : null}
                {/* <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.displayLegend}
                    style={{
                      textAlign: "center",
                      marginLeft: `5px`,
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors["black"],
                          fontSize: "small",
                        }}
                      >
                        Legend
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.state.legendVisible ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div> */}

                {/* {this.state.legendVisible ? (
                  <React.Fragment>
                    <center>
                      {test ? (
                        <p
                          style={{
                            textAlign: "center",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          {test} <br />
                          (mm/day)
                          <br />
                          {this.props.activeDate}
                        </p>
                      ) : null}
                      <div className="info legend">{this.state.legend}</div>


                    </center>
                  </React.Fragment>
                ) : null} */}
              </div>
              <div></div>
            </OffCanvasMenu>
          </OffCanvas>
        </Control>

        {/* {!this.props.visibleGraphPanel && this.props.chartData !== null ? (
          <Control position="bottomright">
            <Popup
              trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel}
                  secondary
                  style={{ backgroundColor: colors.sidebar }}
                  compact
                  size="medium"
                >
                  <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null} */}

        {/* <Control
          position="bottomleft"
          style={{ pointerEvents: "auto", cursor: "auto" }}
        >
          <DateSlider {...this.props.sliderOptions} />
        </Control> */}
        <MouseControl position="bottomleft" />
        <ScaleControl metric={true} />
      </Map>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    minZoom: state.CState.minZoom,
    maxZoom: state.CState.maxZoom,
    center: state.CState.indiamapcenter,
    zoom: state.CState.zoom,
    url: state.CState.url1,
    layers: state.CState.layers1,
    baselayerselected: state.CState.baselayerselected1,
    attributionControl: state.CState.attributionControl,
    crs: state.CState.crs,
    baseLayers: state.CState.baseLayers1,
    chartData: state.ETState.chartData,
  };
};
export default connect(mapStateToProps, {
  common_state,
  changeBaseLayer,
  displayBaseLayerPanel,
  showInfo_f,
})(MapView);
